import script from "./FilialeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilialeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./FilialeSelector.vue?vue&type=style&index=0&id=616da644&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616da644"]])

export default __exports__